import {AbstractParameter} from "parameters/AbstractParameter.js"
import ParameterContext from "effects/ParameterContext.js";
import {bulkUpdate} from "utils/bulkUpdate.js";
import {saveParameterToJson, loadParameterFromJson} from "parameters/parameterJsonFunctions.js";
import {fig} from '../scripting/t_figure.js';
import {tparse} from '../scripting/tidal.js';
import Registered from "utils/Registered.js";
import {FIGURES} from './constants.js';
import {getCycleString} from '../tidal/parser.js';

export default class Figure extends Registered(class {}) {
    constructor(figure, effect) {
        super();
        this.effect = effect;
        this.sequencerEngine = effect.sequencerEngine;
        this.figure = figure;
        this._initialType = 0;
        this._initialLength = figure().flat(3).length;
        this.figureLengthParameter = new AbstractParameter(
            "figureLength",
            this,
            (o,x) => this.onLengthChanged(x),
            {
                defaultValue: this._initialLength,
                min: 3,
                max: 5
            });

        this.registerParameter(this.figureLengthParameter);

        this.figureTypeParameter = new AbstractParameter(
            "figureType",
            this,
            (o,x) => this.onTypeChanged(x),
            {
                defaultValue: this._initialType,
                min: 0,
                max: 7
            });

        this.registerParameter(this.figureTypeParameter);

        this.registerContext();
    }

    registerContext() {
        let parameters = this.parameters;
        let context = new ParameterContext().forMidiEffect(this.effect);
        parameters.forEach(
            p => {
                p.setContext(context);
                p.setStore(this.sequencerEngine.store);
            });
    }

    updateFigure(figure) {
        // need to figure out the type and length from this compiled
        // figure

        figure = figure();
        let length = figure.flat(3).length;

        let types = FIGURES[length];
        let str = getCycleString(figure);
        let type = types.indexOf(str.trim());

        this.figureLengthParameter.set(length);
        this.figureTypeParameter.set(type);
    }

    get figureLength() {
        return this.figureLengthParameter ? this.figureLengthParameter.get() :
            this._initialLength;
    }

    get figureType() {
        return this.figureTypeParameter ? this.figureTypeParameter.get() :
            this._initialType;
    }

    onTypeChanged(type) {
        type = Math.round(type);
        let length = Math.min(5, Math.max(3, Math.round(this.figureLength)));
        let types = FIGURES[length];

        let figure = types[type % types.length];
        this.figure = fig(tparse(figure))();
        this.effect.onFiguresChanged();
    }

    onLengthChanged(length) {
        length = Math.min(5, Math.max(3, Math.round(length)));
        let types = FIGURES[length];
        let type = Math.round(this.figureType);

        let figure = types[type % types.length];
        this.figure = fig(tparse(figure))();
        this.effect.onFiguresChanged();
    }

    toString() {
        return getCycleString(this.figure);
    }

    getJson() {
        let json = {
            figureLength: this.figureLength,
            figureType: this.figureType,
        };

        json = saveParameterToJson(json, 'figureLengthParameter', this.figureLengthParameter);
        json = saveParameterToJson(json, 'figureTypeParameter', this.figureTypeParameter);

        return json;
    }

    fromJson(json) {
        let bulk = {};
        bulkUpdate(this.figureLengthParameter, json.figureLength, bulk);
        bulkUpdate(this.figureTypeParameter, json.figureType, bulk);
        return {
            ... bulk,
            ... loadParameterFromJson(json, 'figureLengthParameter', this.figureLengthParameter),
            ... loadParameterFromJson(json, 'figureTypeParameter', this.figureTypeParameter)
        };
    }
}
